export default function loader() {
    window.onload = function () {
        const spinner = document.getElementById('loading');
        spinner.classList.add('loaded');
    }
}